// =========================
// Domain result (what the UI sees)
// =========================

export type AddToCartResult =
  | {
      type: "SUCCESS";
    }
  | {
      type: "PARTIAL_SUCCESS";
      message: string;
      quantityAvailable: number;
    }
  | {
      type: "ERROR";
      message: string;
    };

// =========================
// GraphQL payload (what the API returns)
// =========================

type AddToCartPayload =
  | {
      __typename: "Order";
    }
  | {
      __typename: "InsufficientStockError";
      message: string;
      quantityAvailable: number;
      order: {
        lines: unknown[];
        totalQuantity: number;
      };
    }
  | {
      __typename:
        | "OrderLimitError"
        | "OrderModificationError"
        | "NegativeQuantityError";
      message: string;
    };

// =========================
// Resolver
// =========================

export const resolveAddToCartResult = (
  result: AddToCartPayload | null | undefined
): AddToCartResult => {
  if (!result) {
    return {
      type: "ERROR",
      message: "Unknown error",
    };
  }

  switch (result.__typename) {
    case "Order":
      return {
        type: "SUCCESS",
      };

    case "InsufficientStockError": {
      const hasItems =
        result.order?.lines?.length > 0 && result.order.totalQuantity > 0;

      if (!hasItems) {
        // ❗ Nothing was added → real error
        return {
          type: "ERROR",
          message: result.message,
        };
      }

      // Partial success only if cart actually changed
      return {
        type: "PARTIAL_SUCCESS",
        message: result.message,
        quantityAvailable: result.quantityAvailable,
      };
    }

    case "OrderLimitError":
    case "OrderModificationError":
    case "NegativeQuantityError":
      return {
        type: "ERROR",
        message: result.message,
      };

    default:
      return {
        type: "ERROR",
        message: "Unexpected response",
      };
  }
};
